export enum ServiceSetupProgress {
  SETUP_DEFINITION = 1,
  CREATE_CONFIGURATION_ENVIRONMENT = 2,
  DEFINE_PTL_WORKFLOW = 3,
  DEPLOY_PTL = 4,
}
